module.exports = __webpack_public_path__ + "img/ser7.2d82de57.png";